import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';

import { MatDialog } from '@angular/material/dialog';
import { PedidoRelatorioElement } from '../../interfaces/pedido.relatorio';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';

import { ExcelService } from '../../services/excel.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-relatorio-comissao',
  templateUrl: './relatorio-comissao.component.html',
  styleUrls: ['./relatorio-comissao.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioComissaoComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  range: FormGroup;
  datePickerRotaControl: FormControl;

  auxPedidos: PedidoRelatorioElement[] = [];

  somaTotal: number = 0;
  totalComissao: number = 0;

  contEntregues: number = 0;
  contCancelados: number = 0;
  //Pagamentos
  contPagamentoPendente: number = 0;
  contPagamentoConfirmado: number = 0;
  contPagamentoCancelado: number = 0;
  contPagamentoBoleto: number = 0;
  contPagamentoCredito: number = 0;
  contPagamentoDebito: number = 0;
  contPagamentDinheiro: number = 0;

  sBuscaStatusPedido: string = 'Todos';
  sBuscaStatusPagamento: string = 'Todos';

  sBuscaVendedor: string;
  aVendedores: any[] = [];
  comissaoUtilizada: number = 1;

  sMesBusca: number = 0;
  aMesBusca: any[] = []

  sAnoBusca: string;
  aAnosBusca: any[] = []

  $pedidos;
  tipoCadastro = 'Vendedor';

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private af: AngularFireAuth

  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });


    this.aMesBusca = [{ value: 0, name: 'Janeiro' }, { value: 1, name: 'Fevereiro' }, { value: 2, name: 'Março' }, { value: 3, name: 'Abril' }
      , { value: 4, name: 'Maio' }, { value: 5, name: 'Junho' }, { value: 6, name: 'Julho' }, { value: 7, name: 'Agosto' }
      , { value: 8, name: 'Setembro' }, { value: 9, name: 'Outubro' }, { value: 10, name: 'Novembro' }, { value: 11, name: 'Dezembro' }];

    this.sMesBusca = this.aMesBusca[(new Date().getMonth())].value;

    var date = new Date();
    var aux = 0;
    for (var i = 2021; i <= date.getFullYear(); i++) {
      this.aAnosBusca.push({
        value: aux,
        name: '' + i,
      });
      aux++;
    }
    this.sAnoBusca = '' + date.getFullYear();
  }

  ngOnInit(): void {
    //Recupera os funcionários / Vendedores
    this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
      this.aVendedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.Status && dados.Permissoes.Vender) {
            this.aVendedores.push({
              value: item.key,
              name: dados.Nome,
              comissao: dados.Comissao
            });
          }
        });

        //Ordena alfabeticamente
        this.aVendedores.sort((a, b) => a.value.localeCompare(b.value));

        this.sBuscaVendedor = this.aVendedores[0].value
      }

      if (this.tipoCadastro === 'Vendedor') {
        this.sBuscaVendedor = this.uid;
      }
    });
  }

  buscarVendasPeriodo() {

    this.spinner.show('relatorio-comissao');
    let timestampInicio: Date = new Date(Number(this.sAnoBusca), this.sMesBusca + 1, 0);
    timestampInicio.setDate(1);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(Number(this.sAnoBusca), this.sMesBusca + 1, 0);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);

    let aux: any = this.aVendedores.filter((a) => a.value === this.sBuscaVendedor);
    this.comissaoUtilizada = aux[0].comissao;

    this.somaTotal = 0;
    this.contEntregues = 0;
    this.contCancelados = 0;
    this.contPagamentoPendente = 0;
    this.contPagamentoConfirmado = 0;
    this.contPagamentoCancelado = 0;
    this.contPagamentoBoleto = 0;
    this.contPagamentoCredito = 0;
    this.contPagamentoDebito = 0;
    this.contPagamentDinheiro = 0;
    this.totalComissao = 0;

    this.usuarioService.getComissao(this.usuarioService.tratarMesData(timestampInicio.getTime())).pipe(take(1)).subscribe(snap => {
      if (snap.length > 0) {
        snap.forEach((item, index) => {
          const dados: any = item.payload.val();
          this.comissaoUtilizada = dados.MapVendedores[this.sBuscaVendedor].Comissao ? dados.MapVendedores[this.sBuscaVendedor].Comissao : aux[0].comissao;
        });
      }

      this.gerarRelatorio(timestampInicio, timestampFinal);
    });
  }

  gerarRelatorio(timestampInicio, timestampFinal) {
    this.$pedidos = this.usuarioService.getPedidosIDVendedorTimestamp(this.sBuscaVendedor, timestampInicio.getTime(), timestampFinal.getTime()).pipe(take(1)).subscribe(snap => {
      if (snap.length > 0) {
        this.auxPedidos = [];
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (
            (this.validarFiltro('Status do pedido', dados.Status)) &&
            (this.validarFiltro('Status do pagamento', dados.StatusPagamento)) &&
            (this.validarFiltro('Vendedor', dados.IDVendedor))
          ) {
            this.auxPedidos.push({
              ID: item.key,
              Bairro: dados.Bairro,
              BandeiraCartao: dados.BandeiraCartao,
              CEP: dados.CEP,
              Cidade: dados.Cidade,
              Complemento: dados.Complemento,
              Email: dados.Email,
              FormaPagamento: dados.FormaPagamento,
              NumeroParcelas: dados.NumeroParcelas,
              IDVendedor: dados.IDVendedor,
              Logradouro: dados.Logradouro,
              Nome: dados.Nome,
              Numero: dados.Numero,
              Observacao: dados.Observacao,
              Referencia: dados.Referencia,
              Status: dados.Status,
              StatusPagamento: dados.StatusPagamento,
              Telefone: dados.Telefone,
              TelefoneSecundario: dados.TelefoneSecundario,
              Total: 'R$ ' + dados.Total.toFixed(2).replace('.', ','),
              UF: dados.UF,
              Data: this.usuarioService.tratarData(dados.Timestamp),
              Hora: this.usuarioService.tratarHora(dados.Timestamp),
              DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '-',
              HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '-',
              DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '-',
              HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '-',
              DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '-',
              HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '-',
              DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '-',
              HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '-',
              MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '-',
              DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '-',
              Plataforma: dados.Plataforma,
              IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '-',
              Dispositivo: dados.Dispositivo
            });

            dados.Status === 'Entregue' ? this.somaTotal += dados.Total : null;

            dados.Status === 'Entregue' ? this.contEntregues++ : null;
            dados.Status === 'Cancelado' ? this.contCancelados++ : null;

            dados.StatusPagamento === 'Pendente' ? this.contPagamentoPendente++ : null;
            dados.StatusPagamento === 'Pago' ? this.contPagamentoConfirmado++ : null;
            dados.StatusPagamento === 'Cancelado' ? this.contPagamentoCancelado++ : null;

            dados.FormaPagamento === 'Boleto' ? this.contPagamentoBoleto++ : null;
            dados.FormaPagamento === 'Cartão de crédito' ? this.contPagamentoCredito++ : null;
            dados.FormaPagamento === 'Cartão de débito' ? this.contPagamentoDebito++ : null;
            dados.FormaPagamento === 'Dinheiro' ? this.contPagamentDinheiro++ : null;
          }
        });
        // this.auxPedidos = this.auxPedidos.reverse();

        this.usuarioService.setLog("Consulta relatório de comissão. Vendedor: " + this.sBuscaVendedor + ' período: ' + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);
        this.totalComissao = this.somaTotal * (0.01 * this.comissaoUtilizada);

        this.bConsulta = true;

        setTimeout(() => this.spinner.hide('relatorio-comissao'), 300);
      } else {
        this.toastr.error("Não foi possível localizar pedidos!", 'Erro');
        setTimeout(() => this.spinner.hide('relatorio-comissao'), 300);
      }
    });
  }

  validarFiltro(tipo, status) {
    switch (tipo) {
      case 'Status do pedido':
        return this.sBuscaStatusPedido === 'Todos' ? true : status === this.sBuscaStatusPedido;

      case 'Status do pagamento':
        return this.sBuscaStatusPagamento === 'Todos' ? true : status === this.sBuscaStatusPagamento;

      case 'Vendedor':
        return this.sBuscaVendedor === 'Todos' ? true : status === this.sBuscaVendedor;

      default: return false;
    }
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    let date: Date = new Date(Number(this.sAnoBusca), this.sMesBusca + 1, 0);
    date.setDate(1);

    let dateFinal: Date = new Date(Number(this.sAnoBusca), this.sMesBusca + 1, 0);

    const map = {
      Soma: this.somaTotal,
      ContEntregues: this.contEntregues,
      ContCancelados: this.contCancelados,
      ContPagamentoPendente: this.contPagamentoPendente,
      ContPagamentoConfirmado: this.contPagamentoConfirmado,
      ContPagamentoCancelado: this.contPagamentoCancelado,
      ContPagmentoBoleto: this.contPagamentoBoleto,
      ContPagamentoCredito: this.contPagamentoCredito,
      ContPagamentoDebito: this.contPagamentoDebito,
      ContPagamentoDinheiro: this.contPagamentDinheiro,
      Periodo: this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime())
    }
    let auxExportar = []
    let auxVendedorUtilizado: any = this.aVendedores.filter((a) => a.value === this.sBuscaVendedor);

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.auxPedidos.forEach(dado => {
          if (dado.Status === 'Entregue' || dado.Status === 'Cancelado') {
            var aux = [dado.ID, dado.Data, dado.Bairro, dado.Cidade, dado.Nome, dado.FormaPagamento, dado.StatusPagamento, dado.Status, dado.DataEntregue, dado.Total];
            corpo.push(aux);
          }
        });

        autoTable(doc, {
          head: [["Pedido", "Data", "Bairro", "Cidade", "Cliente", "Forma de PGT", "Status PGT", "Status", "Data da entrega", "Total"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [["", "", "", "", "", "", "", "Comissão: " + this.comissaoUtilizada + "%", "Comissão: R$ " + this.totalComissao.toFixed(2).replace('.', ','), "Total: R$ " + this.somaTotal.toFixed(2).replace('.', ',')]]
        });
        doc.save('Relatório_Comissão_Vendedor_' + auxVendedorUtilizado[0].name + ' ' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de comissão em PDF. Vendedor: " + this.sBuscaVendedor + " Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);
        break;

      //Excel
      case 1:
        this.auxPedidos.forEach(dado => {
          if (dado.Status === 'Entregue' || dado.Status === 'Cancelado') {
            auxExportar.push({
              ID: dado.ID,
              Bairro: dado.Bairro,
              BandeiraCartao: dado.BandeiraCartao,
              CEP: dado.CEP,
              Cidade: dado.Cidade,
              Complemento: dado.Complemento,
              Email: dado.Email,
              FormaPagamento: dado.FormaPagamento,
              IDVendedor: dado.IDVendedor,
              Logradouro: dado.Logradouro,
              Nome: dado.Nome,
              Numero: dado.Numero,
              Observacao: dado.Observacao,
              Referencia: dado.Referencia,
              Status: dado.Status,
              StatusPagamento: dado.StatusPagamento,
              Telefone: dado.Telefone,
              TelefoneSecundario: dado.TelefoneSecundario,
              Total: dado.Total,
              UF: dado.UF,
              Data: dado.Data,
              Hora: dado.Hora,
              DataSeparacao: dado.DataSeparacao,
              HoraSeparacao: dado.HoraSeparacao,
              DataRota: dado.DataRota,
              HoraRota: dado.HoraRota,
              DataEntregue: dado.DataEntregue,
              HoraEntregue: dado.HoraEntregue,
              DataCancelado: dado.DataCancelado,
              HoraCancelado: dado.HoraCancelado,
              MotivoCancelamento: dado.MotivoCancelamento,
              DataHoraPagamento: dado.DataHoraPagamento,
              Dispositivo: dado.Dispositivo
            })
          }
        });

        this.excelService.exportAsExcelFile(auxExportar, 'Relatório_Comissão_Vendedor_' + auxVendedorUtilizado[0].name + ' ' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()));

        this.usuarioService.setLog("Exportou relatório de comissão em EXCEL. Vendedor: " + this.sBuscaVendedor + " Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);
        break;

      //CSV
      case 2:
        var options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()),
          useBom: true,
          noDownload: false,
          headers: ["Pedido", "Bairro", "Bandeira cartão", "CEP", "Cidade", "Complemento", "Email", "Forma de pagamento", "IDVendedor", "Logradouro", "Nome", "Numero", "Observacao", "Referencia", "Status", "Status do pagamento", "Telefone", "Telefone secundário", "Total", "UF", "Data", "Hora", "Data da separação", "Hora da separação", "Data da rota", "Hora da rota", "Data da entrega", "Hora da entrega", "Data do cancelamento", "Hora do cancelamento", "Motivo do cancelamento", "Data e hora do pagamento"],
          nullToEmptyString: true,
        };

        this.auxPedidos.forEach(dado => {
          if (dado.Status === 'Entregue' || dado.Status === 'Cancelado') {
            auxExportar.push({
              ID: dado.ID,
              Bairro: dado.Bairro,
              BandeiraCartao: dado.BandeiraCartao,
              CEP: dado.CEP,
              Cidade: dado.Cidade,
              Complemento: dado.Complemento,
              Email: dado.Email,
              FormaPagamento: dado.FormaPagamento,
              IDVendedor: dado.IDVendedor,
              Logradouro: dado.Logradouro,
              Nome: dado.Nome,
              Numero: dado.Numero,
              Observacao: dado.Observacao,
              Referencia: dado.Referencia,
              Status: dado.Status,
              StatusPagamento: dado.StatusPagamento,
              Telefone: dado.Telefone,
              TelefoneSecundario: dado.TelefoneSecundario,
              Total: dado.Total,
              UF: dado.UF,
              Data: dado.Data,
              Hora: dado.Hora,
              DataSeparacao: dado.DataSeparacao,
              HoraSeparacao: dado.HoraSeparacao,
              DataRota: dado.DataRota,
              HoraRota: dado.HoraRota,
              DataEntregue: dado.DataEntregue,
              HoraEntregue: dado.HoraEntregue,
              DataCancelado: dado.DataCancelado,
              HoraCancelado: dado.HoraCancelado,
              MotivoCancelamento: dado.MotivoCancelamento,
              DataHoraPagamento: dado.DataHoraPagamento,
              Dispositivo: dado.Dispositivo
            })
          }
        });

        new Angular5Csv(auxExportar, 'Relatório_Comissão_Vendedor_' + auxVendedorUtilizado[0].name + ' ' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), options);
        this.usuarioService.setLog("Exportou relatório de comissão em CSV. Vendedor: " + this.sBuscaVendedor + " Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);

        break;
    }
  }

}